namespace My {
    export class PasswordRecoveryService extends BaseService {
        constructor(baseUrl?: string) {
            super(Utils.isEmpty(baseUrl) ? "/password-recovery" : baseUrl);
        }


        public async resetPassswordByPhoneNumber(request) {
            var url = "reset-password-by-phone-number";
            var res = await this.postJson(url, request)
            return res.result;
        }

        public async resetPassswordByEmail(request) {
            var url = "reset-password-by-email";
            var res = await this.postJson(url, request)
            return res.result;
        }

        public async generateResetPasswordToken(emailOrPhone, isEmail) {
            var url = `generate-reset-password-token?emailOrPhone=${emailOrPhone}&isEmail=${isEmail}`;
            var res = await this.getJson(url)
            return res.result;
        }
    }
}